import * as CSS from 'csstype';

export const menuDiv: CSS.Properties = { 
    backgroundColor: '#6A7FDB',
    position: 'fixed',
    marginTop: '-1.5rem',
    paddingTop: '1rem',
    height: '105%'

}

export const iconStyle: CSS.Properties = { 
    marginRight: '.5rem',
    color: '#45CB85'
}